// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"6":"953db841","141":"6b688298","732":"a389ff4e","908":"8d2ffc52"}[chunkId] + ".js";
};